import React, {PureComponent} from "react";
import {Col, Row} from "reactstrap";
import Widget from '../../../components/Widget';
import BarChart from './../charts/BarChart';
import PieChart from './../charts/PieChart';
import {Ejecutivo} from './../objects/ejecutivo'
import {Cumplimiento} from "./../objects/cumplimiento";
import ComplianceBarchart from './../charts/ComplianceBarChart';
import {CumplimientoTotal} from "./../objects/cumplimientoTotal";
import PubSub from "pubsub-js";



export class BankDetail extends PureComponent {
    state = {
        data : [],
        compliance: [],
        totalCompliance: [],
        maxYear : this.props.maxYear,
        mes : this.props.mes,
        sectional : this.props.sectional
    }

    componentDidMount() {
        PubSub.subscribe('reloadmaxYear', this.onmaxyaer.bind(this));
        this.props.onLoading(true);
        this.getbankCompliance(this.state.maxYear, this.props.mes, this.props.sectional);
    }

    onmaxyaer() {
        console.log(this.props.maxYear);
        this.props.onLoading(true);
        this.setState({
            maxYear: this.props.maxYear
        })
        this.props.onLoading(false);
    }
    onmes() {
        console.log(this.props.mes);
        this.props.onLoading(true);
        this.setState({
            mes: this.props.mes
        })
        this.props.onLoading(false);
    }
    onsectional() {
        console.log(this.props.sectional);
        this.props.onLoading(true);
        this.setState({
            sectional: this.props.sectional
        })
        this.props.onLoading(false);
    }

    componentDidUpdate() {
        this.props.onLoading(true);
        if (this.state.maxYear  != this.props.maxYear || this.state.mes != this.props.mes || this.state.sectional != this.props.sectional) {
            this.getbankCompliance(this.props.maxYear, this.props.mes, this.props.sectional);
        }
    }

     getbankCompliance(anio,mes,sectional) {
         this.props.onLoading(true);
         console.log(anio);
         if(anio!= null){
             this.API_URL = "/bankCompliance/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
             console.log(this.API_URL);
         }
         fetch(this.API_URL)
             .then((res) => res.json())
             .then((data1) => {
                 var structure = []
                 data1.map(item => {
                     var ejecutivo = new Cumplimiento(item.Banco, item.Afiliaciones, item.Meta);
                     structure.push(ejecutivo);
                 });
                 this.setState(() => ({
                     data: structure
                 }), ()=>{
                     this.props.onLoading(false);
                 })
             });
    }



    render() {
        return(
                <Row>
                    <Col xs={12} md={8}>
                        <Widget
                            title={<h5><span className="fw-semi-bold">Afiliaciones efectivas</span></h5>}>
                            <BarChart data={this.state.data} />
                        </Widget>
                    </Col>
                    <Col xs={12} md={4}>
                        <Widget
                            title={<h5><span className="fw-semi-bold">Cumplimiento acumulado</span></h5>}>
                            <PieChart data={this.state.data} />
                        </Widget>
                    </Col>
                    <Col xs={12} md={12}>
                        <Widget
                            title={<h5><span className="fw-semi-bold">Cumplimiento</span></h5>}>
                            <ComplianceBarchart data={this.state.data} />
                        </Widget>
                    </Col>
                </Row>
        )
    }
}